import { SVGProps } from 'react';

const SquareUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m10 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default SquareUser;
